<template>
  <div class="d-flex">
    <v-select
      v-model="depositValueSignal"
      :items="depositValueSignalItems"
      @change="setDepositValue"
      :label="byDepositValueLabel"
      prepend-icon="mdi-cash-check"
      item-text="text"
      item-value="value"
      return-object
      dense
      filled
      hide-details
      solo-inverted
    ></v-select>
    <v-text-field
      v-model="depositValue"
      @change="setDepositValue"
      :placeholder="depositValueLabel"
      :min="minDepositValue"
      :prefix="depositValuePrefix"
      class="ml-2"
      type="number"
      solo-inverted
      dense
      hide-details
    ></v-text-field>
  </div>
</template>
<script>
export default {
  name: "DepositValueFilter",
  data: () => ({
    depositValueSignal: {
      text: "",
      option: "",
    },
    depositValue: "",
    minDepositValue: 1,
  }),
  watch: {
    depositValueStore(value) {
      this.depositValueSignal = this.depositValueSignalItems.find(
        (item) => item.option === value.option
      );
      this.depositValue = value.value;
    },
  },
  computed: {
    depositValueSignalItems() {
      return [
        { text: this.$t("exactDepositValue"), option: "exatamente" },
        { text: this.$t("moreThanDepositValue"), option: "maior" },
        { text: this.$t("lessThanDepositValue"), option: "menor" },
      ];
    },
    depositValueStore() {
      return this.$store.state.filters.depositValue;
    },
    byDepositValueLabel() {
      return this.$t("byDepositValue");
    },
    depositValueLabel() {
      return this.$t("value");
    },
    depositValuePrefix() {
      return this.$t("labelCurrency");
    },
  },
  methods: {
    setDepositValue() {
      this.$store.commit("setDepositValue", {
        option: this.depositValueSignal.option,
        value: parseInt(this.depositValue) > 0 ? this.depositValue : "",
      });
    },
  },
};
</script>
